import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link, useNavigate } from "react-router-dom";
import LogoWhite from "../../img/LogoWhite.png";
import styles from "./navbar.module.css";
import { BsHandbag } from "react-icons/bs";
import { FaTrashAlt } from "react-icons/fa";
import { IoPersonCircleOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { removeItemFromCart } from "../../redux/userSlice";
import { logout } from "../../redux/userSlice";
import { NavDropdown } from "react-bootstrap";
import CounterNoInput from "../QtyCounter/CounterNoInput";
import Swal from "sweetalert2";

function NavBar() {
  const [expanded, setExpanded] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cart = useSelector((state) => state.cart);
  const user = useSelector((state) => state.user);
  const cartSubtotal = cart.reduce((a, c) => a + c.price * c.qty, 0);

  const qtyTotal = cart.reduce((a, c) => a + c.qty, 0);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
    Toast.fire({
      icon: "success",
      title: `Fuiste deslogueado con exito `,
    });
  };

  function deleteProduct(product) {
    Toast.fire({
      icon: "success",
      title: `Se eliminó correctamente`,
    });
    console.log(product);
    dispatch(removeItemFromCart({ name: product.name }));
  }

  /*   function deleteOneproduct(product) {
    Toast.fire({
      icon: "success",
      title: `Se eliminó 1 unidad correctamente`,
    });
  } */

  const Toast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 1500,
    timerProgressBar: true,
  });

  return (
    <>
      <Navbar className={styles.navbar} expand="lg" expanded={expanded}>
        <Container className={styles.navbarContainer}>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            onClick={() => setExpanded(expanded ? false : "expanded")}
          />
          <div className={styles.leftLogo}>
            <Navbar.Brand className={styles.logo1}>
              <Link to="/">
                <img src={LogoWhite} width="80px" height="50px" alt="LOGO" />
              </Link>
            </Navbar.Brand>
          </div>

          <div className={styles.rightLogo}>
            <Navbar.Brand className={styles.logo2}>
              <Link to="/">
                <img src={LogoWhite} width="80px" height="50px" alt="LOGO" />
              </Link>
            </Navbar.Brand>
          </div>
          <div className={styles.icons + " order-lg-last"}>
            <NavDropdown
              title={<IoPersonCircleOutline />}
              id="userDropdown"
              className={styles.dropdown + ""}
              drop="start"
            >
              {!user.id ? (
                <>
                  <div className="d-flex flex-column">
                    <Link className={styles.dropdownLink} to="/login">
                      Login
                    </Link>
                    <Link to="/register" className={styles.dropdownLink}>
                      Registrarme
                    </Link>
                  </div>
                  <NavDropdown.Item
                    target="_blanc"
                    href="https://pacahack-admin.vercel.app"
                  >
                    Admin
                  </NavDropdown.Item>
                </>
              ) : (
                <>
                  <Link className="dropdown-item" to="/profile">
                    Perfil
                  </Link>
                  <Link to="/order-history" className={styles.dropdownLink}>
                    Mis pedidos
                  </Link>
                  <NavDropdown.Item
                    href="https://pacahack-admin.vercel.app"
                    target="_blanc"
                  >
                    Admin
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => handleLogout()}>
                    Logout
                  </NavDropdown.Item>
                </>
              )}
            </NavDropdown>
            <button
              className={styles.btnCart}
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasExample"
              aria-controls="offcanvasExample"
            >
              <BsHandbag className={styles.cartIcon} />
            </button>
            <div className={styles.divQtyCount}>
              <small
                className={styles.cartCounter}
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasExample"
                aria-controls="offcanvasExample"
              >
                {qtyTotal}
              </small>
            </div>
          </div>

          <Navbar.Collapse id="basic-navbar-nav" className="flex-grow-0">
            <Nav>
              <Link
                onClick={() => setExpanded(false)}
                className={styles.navbar_links}
                to="/products"
              >
                Catálogo
              </Link>

              <Link
                onClick={() => setExpanded(false)}
                className={styles.navbar_links}
                to="/contact"
              >
                Contacto
              </Link>

              <Link
                onClick={() => setExpanded(false)}
                className={styles.navbar_links}
                to="/about"
              >
                Sobre este proyecto
              </Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div className="d-flex flex-column justify-content-between">
        <div
          className={styles.offCanvas + " offcanvas offcanvas-end p-2"}
          tabIndex="-1"
          id="offcanvasExample"
          aria-labelledby="offcanvasExampleLabel"
          data-bs-scroll="true"
        >
          <div className="offcanvas-header">
            <h3
              className="offcanvas-title fs-5 fw-semibold"
              id="offcanvasExampleLabel"
            >
              Shopping Cart
            </h3>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body">
            {cart.length === 0 ? (
              <div className={styles.emptyCart}>
                <BsHandbag className={styles.cartIconOffCanvas} />
                <h4 className="fs-5 text-center">Su carrito está vacío</h4>
                <p className="fs-6 text-muted mt-2 text-center">
                  Llená el carrito y date un{" "}
                  <button
                    data-bs-dismiss="offcanvas"
                    className={styles.btnGustito}
                  >
                    <Link
                      to="/products"
                      style={{ fontWeight: "700" }}
                      className="text-muted"
                    >
                      gustito!
                    </Link>
                  </button>
                </p>
              </div>
            ) : (
              <>
                {cart.map((product, index) => (
                  <div key={index} className={styles.cartItem + " d-flex"}>
                    <div>
                      <img
                        className={styles.itemImage}
                        src={product.image}
                        alt="item"
                      />
                    </div>
                    <div className="w-100 d-flex flex-column justify-content-between mx-2 p-1">
                      <div className="d-flex justify-content-between mt-1">
                        <div className="d-flex flex-column align-items-start">
                          <h6
                            className="fw-semibold mb-0"
                            style={{ color: "#606a72" }}
                          >
                            {product.name}
                          </h6>
                          <small className="text-muted mb-0">
                            Cantidad: {product.qty}
                          </small>
                        </div>
                        <h6
                          className="fw-semibold"
                          style={{ color: "#606a72" }}
                        >
                          $ {product.price * product.qty}
                        </h6>
                      </div>
                      <div className="d-flex justify-content-between align-items-end">
                        <CounterNoInput product={product} />
                        <button
                          className={styles.btnRemove}
                          onClick={() => deleteProduct(product)}
                        >
                          <FaTrashAlt />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
          <div className={styles.offCanvasFooter + " mx-3 mb-3"}>
            <hr />
            <>
              {cart.length === 0 ? (
                <></>
              ) : (
                <>
                  {" "}
                  <span
                    className={
                      styles.cartTotal + " d-flex justify-content-between mt-4"
                    }
                  >
                    <h6 style={{ color: "#606a72" }}>Subtotal</h6>
                    <h6 style={{ color: "#606a72" }}>$ {cartSubtotal}</h6>
                  </span>
                  <p className="text-muted mt-2">
                    Costos de envíos e impuestos calculados al momento de pago.
                  </p>
                  <Link className={styles.linkToCheckout} to="/checkout">
                    <button
                      data-bs-dismiss="offcanvas"
                      className={styles.btnPay}
                    >
                      Ir a pagar
                    </button>
                  </Link>
                </>
              )}
            </>

            <button
              data-bs-dismiss="offcanvas"
              className={styles.btnContinueShopping}
            >
              <Link
                to="/products"
                style={{ fontWeight: "700" }}
                className="text-muted"
              >
                Continuar comprando
              </Link>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default NavBar;
